import { utcDateTime } from './utc-date-time';

export const firstDayOfMonthUTC = (utcDate: string): string => {
  return utcDateTime(utcDate).startOf('month').set({ hour: 12 }).toISO({
    suppressMilliseconds: true,
  });
};
